// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalStyles_modal__PqqX1 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--table-row-white);
  border-radius: 16px;
  width: 510px;
  max-height: 90vh;
  overflow: auto;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  border: 1px solid var(--table-border);

  @media (max-width: 1024px) {
    width: calc(80% - 20px);
  }

  @media (max-width: 760px) {
    width: calc(100% - 20px);
  }
}

.modalStyles_container__\\+g6MJ {
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  width: 100%;
  padding: 32px;
  gap: 20px;
}

.modalStyles_header__Swo2Z {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.modalStyles_closeButton__DQvod {
  padding: 4px !important;
  color: var(--text-secondary) !important;
}

.modalStyles_closeButton__DQvod:hover {
  background-color: var(--table-hover) !important;
  color: var(--text-primary) !important;
}

.modalStyles_button_group__uNgh7 {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 0 0 0;
  margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ModalComponent/modalStyles.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wCAAwC;EACxC,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,iDAAiD;EACjD,qCAAqC;;EAErC;IACE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,+CAA+C;EAC/C,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: var(--table-row-white);\n  border-radius: 16px;\n  width: 510px;\n  max-height: 90vh;\n  overflow: auto;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  border: 1px solid var(--table-border);\n\n  @media (max-width: 1024px) {\n    width: calc(80% - 20px);\n  }\n\n  @media (max-width: 760px) {\n    width: calc(100% - 20px);\n  }\n}\n\n.container {\n  display: flex;\n  box-sizing: border-box;\n  flex-direction: column;\n  width: 100%;\n  padding: 32px;\n  gap: 20px;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.closeButton {\n  padding: 4px !important;\n  color: var(--text-secondary) !important;\n}\n\n.closeButton:hover {\n  background-color: var(--table-hover) !important;\n  color: var(--text-primary) !important;\n}\n\n.button_group {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 20px 0 0 0;\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `modalStyles_modal__PqqX1`,
	"container": `modalStyles_container__+g6MJ`,
	"header": `modalStyles_header__Swo2Z`,
	"closeButton": `modalStyles_closeButton__DQvod`,
	"button_group": `modalStyles_button_group__uNgh7`
};
export default ___CSS_LOADER_EXPORT___;
